import React, { FC } from 'react';

import { FlexItem } from '../../../Flex';
import StickyTop from '../../../StickyTop';
import SidebarPanelButton from '../../SidebarPanelButton';

const SidebarPanelButtonStickyColumn: FC = () => (
  <FlexItem width={40} paddingRight={2}>
    <StickyTop>
      <SidebarPanelButton />
    </StickyTop>
  </FlexItem>
);
export default SidebarPanelButtonStickyColumn;
